export const dataConstants = {
	APP_LOADED: 'app_loaded',
	APP_FULL_WIDTH: 'app_full_width',
	APP_IS_FOCUSED: 'app_is_focused',
	
	SERVER_TIME: 'server_time',
	SERVER_TIME_DIFFERENCE_SECONDS: 'server_time_difference_seconds',
	SERVER_TIMEZONE_OFFSET: 'server_timezone_offset',
	SERVER_TIMEZONE: 'server_timezone',
	
	INITIAL_URL: 'initial_url',
	
	APP_MESSAGES: 'app_messages',
	SETTINGS: 'settings',
	EMPLOYEE: 'employee',
	
	FAVOURITES: 'favourites',

	PARKING_STATUSES: 'parking_statuses',

	EMPLOYEE_EROS: 'employee_eros',

	
	COWORKERS: 'coworkers',

	BOOKINGS: 'bookings',
	BOOKINGS_PAST: 'bookings_past',
	LANGUAGES: 'languages',
	
	//
	BUILDINGS: 'buildings',
	BUILDING_CAPACITIES: 'building_capacities',
	BUILDING_PARKING_SPACES: 'building_parking_spaces',
	FLOORS: 'floors',
	ROOMS: 'rooms',
	TABLES: 'tables',
	
	TIMESLOT_KINDS: 'timeslot_kinds',
	TIMESLOT_GROUPS: 'timeslot_groups',
	
	MEETING_ROOMS: 'meeting_rooms',
	
	BUILDING_FAVOURITES: 'building_favourites',
	FLOOR_FAVOURITES: 'floor_favourites',
	ROOM_FAVOURITES: 'room_favourites',

	TEAMS: 'teams',
	DEPARTMENTS: 'departments',
	JOBTITLES: 'jobtitles',

	//
	INVITATIONS_SENT: 'invitations_sent',
	INVITATIONS_SENT_COUNT: 'invitations_sent_count',
	
	//
	EMPLOYEES: 'employees',
	EMPLOYEES_DETAILED: 'employees_detailed',
	EMPLOYEES_ERO: 'employees_ero',
	EMPLOYEES_CONFIDANTS: 'employees_confidants',
	EMPLOYEES_ERO_LOADED: 'employees_ero_loaded',
	EMPLOYEES_CONFIDANTS_LOADED: 'employees_confidants_loaded',
	EMPLOYEES_BOOKINGS: 'employees_bookings',
	
	EMPLOYEE_TRANSPORTS: 'employee_transports',
	TIMESLOTS_OCCUPIED: 'timeslots_occupied',
	TIMESLOTS_OCCUPIED_MY_FAVOURITES: 'timeslots_occupied_my_favourites',
	LUNCH_OPTIONS: 'lunch_options',
	
	// Events
	EVENTS: 'events',
	
	// Settings
	SHOW_TAB_BAR: 'show_tab_bar',
	
	// Notifications
	MESSAGES: 'messages',
	MESSAGE_COUNT: 'message_count',
	NOTIFICATIONS: 'notifications',
	
	// Other
	FETCHES: 'fetches',
	FETCHES_HISTORY: 'fetches_history',
	MODE: 'mode',
	IN_MANAGEMENT: 'in_management',

	IGNORE_NOTIFICATIONS: 'ignore_notifications',

	LINKS: 'links',
	
	FILTERS: 'filters',
	FILTER_RESULTS: 'filter_results',
	APPLIED_FILTERS: 'applied_filters',
	APPLIED_FILTERS_CHANGED: 'applied_filters_changed',
	SELECTED_FILTER_OPTIONS: 'selected_filter_options',
	
	// Calendar
	CALENDAR_VIEW_MODE_BOOKINGS: 'calendar_mode_bookings',
	
	ALERT: 'alert',
};
